import { gql } from 'graphql-request';

export const INCIDENT_FIELDS = gql`
  fragment IncidentFields on IncidentDto {
    incidentId
    name
    description
    incidentTime
    delay
    delayUnitOfMeasure
    incidentType
    otherIncidentType
    status
    acknowledgedBy
    acknowledgedAt
    userId
    projectId
    organizationId
    createdAt
    acknowledgedByUser {
      firstName
      lastName
    }
    user {
      firstName
      lastName
    }
    project {
      name
      projectId
    }
    tasks {
      taskId
      name
    }
    documents {
      documentId
      name
      url
    }
  }
`;

export const getIncident = gql`
  query getIncident($incidentId: String!) {
    getIncident(incidentId: $incidentId) {
      ...IncidentFields
    }
  }
  ${INCIDENT_FIELDS}
`;

export const getIncidentsByProject = gql`
  query getIncidentsByProject($projectId: String!) {
    getIncidentsByProject(projectId: $projectId) {
      ...IncidentFields
    }
  }
  ${INCIDENT_FIELDS}
`;

export const getIncidentsByTask = gql`
  query getIncidentsByTask($taskId: String!) {
    getIncidentsByTask(taskId: $taskId) {
      ...IncidentFields
    }
  }
  ${INCIDENT_FIELDS}
`;

export const getIncidentsByOrganization = gql`
  query getIncidentsByOrganization($organizationId: String!) {
    getIncidentsByOrganization(organizationId: $organizationId) {
      ...IncidentFields
    }
  }
  ${INCIDENT_FIELDS}
`;

export const getPendingIncidents = gql`
  query getPendingIncidents($organizationId: String!) {
    getPendingIncidents(organizationId: $organizationId) {
      ...IncidentFields
    }
  }
  ${INCIDENT_FIELDS}
`;

export const getIncidentsByStatus = gql`
  query getIncidentsByStatus(
    $organizationId: String!
    $status: IncidentStatus!
  ) {
    getIncidentsByStatus(organizationId: $organizationId, status: $status) {
      ...IncidentFields
    }
  }
  ${INCIDENT_FIELDS}
`;

export const createIncident = gql`
  mutation createIncident($incident: IncidentCreateInput!) {
    createIncident(incident: $incident) {
      ...IncidentFields
    }
  }
  ${INCIDENT_FIELDS}
`;

export const updateIncident = gql`
  mutation updateIncident($incident: IncidentUpdateInput!) {
    updateIncident(incident: $incident) {
      ...IncidentFields
    }
  }
  ${INCIDENT_FIELDS}
`;

export const acknowledgeIncident = gql`
  mutation acknowledgeIncident($incidentId: String!) {
    acknowledgeIncident(incidentId: $incidentId) {
      ...IncidentFields
    }
  }
  ${INCIDENT_FIELDS}
`;

const IncidentsGraphQL = {
  queries: {
    getIncident,
    getIncidentsByProject,
    getIncidentsByTask,
    getIncidentsByOrganization,
    getPendingIncidents,
    getIncidentsByStatus,
  },
  mutations: {
    createIncident,
    updateIncident,
    acknowledgeIncident,
  },
};

export default IncidentsGraphQL;
